const { createSelector } = require("reselect");

const selectCreateUser = (state) => state.kycDomain.createUser;

const createKycUser = () =>
  createSelector([selectCreateUser], (cse) => cse.data);

const createKycUserError = () =>
  createSelector([selectCreateUser], (cse) => cse.error);

const createKycUserLoading = () =>
  createSelector([selectCreateUser], (cse) => cse.loading);

const selectGetUser = (state) => state.kycDomain.getUser;

const getKycUser = () => createSelector([selectGetUser], (cse) => cse.data);

const getKycUsersError = () =>
  createSelector([selectGetUser], (cse) => cse.error);

const getKycUserLoading = () =>
  createSelector([selectGetUser], (cse) => cse.loading);

const selectUpdateUser = (state) => state.kycDomain.updateUser;

const updateKycUser = () =>
  createSelector([selectUpdateUser], (cse) => cse.data);

const updateKycUserError = () =>
  createSelector([selectUpdateUser], (cse) => cse.error);

const updateKycUserLoading = () =>
  createSelector([selectUpdateUser], (cse) => cse.loading);

module.exports = {
  createKycUser,
  createKycUserError,
  createKycUserLoading,

  getKycUser,
  getKycUserLoading,
  getKycUsersError,

  updateKycUser,
  updateKycUserLoading,
  updateKycUserError,
};
